import { searchItems } from '../api/search'
import { SearchResult } from '../types/search'
import { searchProtocols } from './searchProtocols'

const sortResults = (results: SearchResult[]) =>
  [...results].sort((left, right) =>
    (right.createdAt || '').localeCompare(left.createdAt || ''),
  )

export const performGlobalSearch = async (
  query: string,
  options: {
    includeProtocols: boolean
    untitledProtocolLabel: string
    userId?: string
  },
): Promise<SearchResult[]> => {
  const normalizedQuery = query.trim()

  if (!normalizedQuery) {
    return []
  }

  const [backendResponse, protocolResults] = await Promise.all([
    searchItems(normalizedQuery),
    options.includeProtocols
      ? searchProtocols(
          normalizedQuery,
          options.untitledProtocolLabel,
          options.userId,
        )
      : Promise.resolve([]),
  ])

  return sortResults([...backendResponse.items, ...protocolResults])
}
